import * as React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import Recalculations from './Recalculations';

export interface IAppProps {
}

export default function UserNavigation(props: any) {

    let { path } = useRouteMatch();

    return (
        <div>
            <Switch>
                <Route path={path}>
                    <Recalculations />
                </Route>
            </Switch>
        </div>
    );
}